var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.129,
    height: 41.131,
    viewBox: "0 0 41.129 41.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M40.049,22.12c-10.218,3.72-14.21,7.709-17.93,17.93a1.657,1.657,0,0,1-3.107,0C15.292,29.83,11.3,25.84,1.082,22.12a1.657,1.657,0,0,1,0-3.107c10.218-3.72,14.21-7.712,17.93-17.93a1.656,1.656,0,0,1,3.107,0c3.72,10.218,7.712,14.21,17.93,17.93a1.657,1.657,0,0,1,0,3.107",
    transform: "translate(-0.001)",
    fill: "#f3f1e4",
    opacity: 0.205
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroStar2);
export default __webpack_public_path__ + "static/media/hero-star-2.6f4ce1549e5719ed7892414784974d08.svg";
export { ForwardRef as ReactComponent };